'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/Audit-comp.png'
import ServiceDetailsImg1 from '../../assets/images/services/audit-and-compliance-1.png'
import ServiceDetailsImg2 from '../../assets/images/services/audit-and-compliance-2.png'
import { Helmet } from 'react-helmet';


const ReliableMain = () => {
    // State to hold dynamic content
    const [serviceDetails] = useState({
        title: "Compliance Auditing",
        text1: "A compliance audit is a comprehensive review of an organization’s adherence to regulatory guidelines. Audit reports evaluate the strength and thoroughness of compliance preparations, security policies, user access controls and risk management procedures over the course of a compliance audit. enable you to feel more confident about the actions you take to protect your family office, employees, operations, facilities, and assets.",
        image1: ServiceDetailsImg,
        title2: "Internal vs. compliance audit",
        text2: "Internal audits are carried out by employees of a company to gauge overall risks to compliance and security and to determine whether the company is following internal guidelines. Internal audits occur throughout the fiscal year and reports can be used by management teams to identify areas that require improvement. Internal audits measure company objectives against output and strategic risks. protection to mitigate threats to your organization.",
        text3: "External audits are formal compliance audits that are carried out by independent third parties and follow a specific format that is determined based on the compliance regulation being assessed. External audit reports measure if an organization is complying with state, federal or corporate regulations, rules and standards.",

        images: [ ServiceDetailsImg1, ServiceDetailsImg2
        ],
        features: [
            {
                icon: "icon-crane-1",
                title: "Reliable Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
            {
                icon: "icon-buildings",
                title: "Building Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
        ],
    });

    return (
        <React.Fragment>
            {/* Service Details Start */}
            <Helmet>
                <title>Audit Compliance - techtotalers</title>
            </Helmet>
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">
                                    <h2 className="service-details__title-one">{serviceDetails.title}</h2>
                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="service-details__img-one">
                                        <img src={serviceDetails.image1} alt="" />
                                    </div>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                    <p className="service-details__text-2">{serviceDetails.text3}</p>
                                </div>
                                <div className="service-details__images-box">
                                    <div className="row">
                                        {serviceDetails.images.map((image, index) => (
                                            <div key={index} className="col-xl-6 col-lg-6">
                                                <div className="service-details__images-single">
                                                    <img src={image} alt="" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="service-details__sidebar">
                                <div className="service-details__service-list-box">
                                <h4 className="service-details__sidebar-title">Main Service</h4>
                                <ul className="service-details__service-list list-unstyled">
                                    <li>
                                    <Link to="/security-consulting">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Security Consulting
                                    </Link>
                                    </li>
                                    <li className="active">
                                    <Link to="/audit-&-compliance">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Audit & Compliance
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/cloud-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Cloud Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/network-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Network Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/design-&-implementation">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Design & Implementation
                                    </Link>
                                    </li>                                
                                      <li>
                                      <Link to="/managed-it-services">
                                        {" "}
                                                                             <span className="icon-dubble-arrow-right" />
                                                                            Managed IT Services
                                                                        </Link>
                                                                        </li>
                                                                        <li>
                                                                        <Link to="/ot-iot-security">
                                                                            {" "}
                                                                            <span className="icon-dubble-arrow-right" />
                                                                            OT, IoT Security
                                                                        </Link>
                                                                        </li>
                                                                        <li>
                                                                        <Link to="/api-security">
                                                                            {" "}
                                                                            <span className="icon-dubble-arrow-right" />
                                                                            API Security
                                                                        </Link>
                                                                        </li>
                                                                        <li>
                                                                        <Link to="/offensive-security-red-teaming">
                                                                            {" "}
                                                                            <span className="icon-dubble-arrow-right" />
                                                                            Offensive Security, Red Teaming
                                                                        </Link>
                                                                        </li>
                                                                        <li>
                                                                        <Link to="/vulnerability-assessment">
                                                                            {" "}
                                                                            <span className="icon-dubble-arrow-right" />
                                                                            Vulnerability Assessment
                                                                        </Link>
                                                                        </li>
                                </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default ReliableMain;
